// angular
//     .module("HeroPRO")
//     .controller("hintsController", hintsController);

import './hints.scss';

export default function hintsController($analytics) {
    const vm = this;
    vm.feedbackProvided = false;
    vm.open = false;

    vm.toggleHintState = function () {
        vm.open = !vm.open;
        const hintEvent = (vm.open) ? 'Reveal Hint' : 'Close Hint';
        const hintLabel = (vm.open) ? 'Open' : 'Close';
        $analytics.eventTrack(hintEvent, { category: `Hints:${vm.id}`, label: hintLabel });
    };

    vm.feedback = function (selection, $event) {
        $event.preventDefault();
        $analytics.eventTrack('Feedback', { category: `Hints:${vm.id}`, label: selection });
        vm.feedbackProvided = true;
    };
}



// WEBPACK FOOTER //
// ./src/app/common/hints/hintsController.js